<template>
  <div style="height:100%"> 
    <div class="mask" v-if="loading">
      <van-loading type="spinner" color="white" />
    </div>
    <div v-if="row.id_cert && !loading" class="box">
      <div class="header2">
        <img :src="row.user.face" alt="" />
        <div class="header_right">
          <h1>{{ row.user.name }}</h1>
          <h2>
            加入啦啦操大家庭<font
              style="
                margin-left: 0.12rem;
                margin-right: 0.12rem;
                font-size: 0.34rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #191919;
                line-height: 0.48rem;
              "
              >{{ row.days }}</font
            >天
          </h2>
          <div class="invite-level">
            <div v-if="userDetail.stars.caipan > 0" class="level_info">
              <img
                class="title-icon"
                src="../../../../assets/images/font-cai@2x.png"
                alt=""
                style="width: 0.25rem; height: 0.25rem"
              />
              <img
                v-if="userDetail.stars.caipan == 1"
                src="../../../../assets/images/icon-star1@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.caipan == 2"
                src="../../../../assets/images/icon-star2@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.caipan == 3"
                src="../../../../assets/images/icon-star3@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.caipan == 4"
                src="../../../../assets/images/icon-star4@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.caipan == 5"
                src="../../../../assets/images/icon-star5@2x.png"
                alt=""
              />
            </div>
            <div v-if="userDetail.stars.yundongyuan > 0" class="level_info">
              <img
                class="title-icon"
                src="../../../../assets/images/font-yun@2x.png"
                alt=""
                style="width: 0.25rem; height: 0.25rem"
              />
              <img
                v-if="userDetail.stars.yundongyuan == 1"
                src="../../../../assets/images/icon-star1@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.yundongyuan == 2"
                src="../../../../assets/images/icon-star2@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.yundongyuan == 3"
                src="../../../../assets/images/icon-star3@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.yundongyuan == 4"
                src="../../../../assets/images/icon-star4@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.yundongyuan == 5"
                src="../../../../assets/images/icon-star5@2x.png"
                alt=""
              />
            </div>
            <div v-if="userDetail.stars.jiaolian > 0" class="level_info">
              <img
                class="title-icon"
                src="../../../../assets/images/font-jiao@2x.png"
                alt=""
                style="width: 0.25rem; height: 0.25rem"
              />
              <img
                v-if="userDetail.stars.jiaolian == 1"
                src="../../../../assets/images/icon-star1@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.jiaolian == 2"
                src="../../../../assets/images/icon-star2@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.jiaolian == 3"
                src="../../../../assets/images/icon-star3@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.jiaolian == 4"
                src="../../../../assets/images/icon-star4@2x.png"
                alt=""
              />
              <img
                v-if="userDetail.stars.jiaolian == 5"
                src="../../../../assets/images/icon-star5@2x.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div style="height:120px"></div>
      <div v-if="row.yundongyuan.list.length > 0">
        <div class="content">
          <div class="content_title">
            <h1>运动员经历及获奖</h1>
            <img src="../../../../assets/images/icon-wuxiji@2x.png" alt="" />
          </div>
          <div class="cate" style="width: 1.68rem"  v-show="row.yundongyuan.grade">
            <h1>{{ row.yundongyuan.grade }}</h1>
            <img
              src="../../../../assets/images/icon-wuxijimore@2x.png"
              alt=""
            />
          </div>
          <div class="sai_list">
            <div v-for="(item, index) in row.yundongyuan.list" :key="index">
              <div v-if="index < max1">
                <div class="list_header" v-if="item.type_name == '参赛'">
                  <h1>{{ item.saiqu_name }}</h1>
                  <img
                    src="../../../../assets/images/icon-wuxijisai@2x.png"
                    alt=""
                  />
                </div>
                <div class="list_header" v-if="item.type_name == '考级'">
                  <h1>{{ item.danwei }}</h1>
                  <img
                    src="../../../../assets/images/tag-kaoji@2x.png"
                    alt=""
                  />
                </div>
                <div class="list_header" v-if="item.type_name == '训练营'">
                  <h1>{{ item.danwei }}</h1>
                  <img
                    src="../../../../assets/images/tag-xunlianying@2x.png"
                    alt=""
                  />
                </div>
                <div class="list_detail" v-if="item.type_name == '参赛'">
                  <img
                    src="../../../../assets/images/icon-grade@2x.png"
                    alt=""
                    style="margin-top: 0.15rem"
                  />
                  <h2>{{ item.prize }}</h2>
                </div>
                <div class="list_detail" v-if="item.type_name == '考级'">
                  <img
                    src="../../../../assets/images/icon-grade@2x.png"
                    alt=""
                    style="margin-top: 0.15rem"
                  />
                  <h2>{{ item.grade }}</h2>
                </div>
                <div class="list_detail" v-if="item.type_name == '训练营'">
                  <img
                    src="../../../../assets/images/icon-grade@2x.png"
                    alt=""
                    style="margin-top: 0.15rem"
                  />
                  <h2>{{ item.project }}</h2>
                </div>
                <div class="list_detail">
                  <img
                    src="../../../../assets/images/icon-time@2x.png"
                    alt=""
                    style="margin-top: 0.06rem"
                  />
                  <h3>{{ item.date }}</h3>
                </div>
                <div class="list_detail" v-if="item.type_name == '参赛'">
                  <img
                    src="../../../../assets/images/icon-people@2x.png"
                    alt=""
                    style="margin-top: 0.06rem"
                  />
                  <h3>{{ item.mingcheng }}</h3>
                </div>
                <div class="br"></div>
              </div>
            </div>
            <div class="more" @click="max1change" v-if="max1show">
              点击查看更多
            </div>
          </div>
        </div>
      </div>
      <div v-if="row.dabiao.length>0">
        <div class="content">
          <div class="content_title">
            <h1>达标资质</h1>
            <img src="../../../../assets/images/icon-wuxiji@2x.png" alt="" />
          </div>
          <div class="cate" @click="downloadDabiao(item)" v-for="(item, index) in row.dabiao" :key="index">
            <h1>{{ item.grade_name }}</h1>
            <img
              src="../../../../assets/images/icon-wuxijimore@2x.png"
              alt=""
            />
          </div>
           
        </div>
      </div>

      <div v-if="row.caipan.grade">
        <div class="content">
          <div class="content_title">
            <h1>裁判员经历</h1>
            <img src="../../../../assets/images/icon-wuxiji@2x.png" alt="" />
          </div>
          <div class="cate" @click="toCaipan">
            <h1>{{ row.caipan.grade }}</h1>
            <img
              src="../../../../assets/images/icon-wuxijimore@2x.png"
              alt=""
            />
          </div>
          <div class="sai_list" v-show="row.caipan.list.length>0">
            <div v-for="(item, index) in row.caipan.list" :key="index">
              <div v-if="index < max2">
                <div class="list_header" v-if="item.type_name == '培训'">
                  <h1>{{ item.station_name }}</h1>
                  <img
                    src="../../../../assets/images/tag-peixun@2x.png"
                    alt=""
                  />
                </div>
                <div class="list_header" v-if="item.type_name == '执裁'">
                  <h1>{{ item.saiqu_name }}</h1>
                  <img
                    src="../../../../assets/images/tag-zhicai@2x.png"
                    alt=""
                  />
                </div>
                <div class="list_detail" v-if="item.type_name == '培训'">
                  <img
                  v-if="item.grade"
                    src="../../../../assets/images/icon-grade@2x.png"
                    alt=""
                    style="margin-top: 0.15rem"
                  />
                  <h2 v-if="item.grade">{{ item.grade }}</h2>
                </div>
                <div class="list_detail" v-if="item.type_name == '执裁'">
                  <img
                    src="../../../../assets/images/icon-grade@2x.png"
                    alt=""
                    style="margin-top: 0.15rem"
                  />
                  <h2>{{ item.role_name }}</h2>
                </div>
                <div class="list_detail">
                  <img
                    src="../../../../assets/images/icon-time@2x.png"
                    alt=""
                    style="margin-top: 0.06rem"
                  />
                  <h3>{{ item.date }}</h3>
                </div>
                <div class="br"></div>
              </div>
            </div>
            <div class="more" @click="max2change" v-if="max2show">
              点击查看更多
            </div>
          </div>
        </div>
      </div>
      <div v-if="row.jiaolian.grade">
        <div class="content">
          <div class="content_title">
            <h1>教练员经历</h1>
            <img src="../../../../assets/images/icon-wuxiji@2x.png" alt="" />
          </div>
          <div class="cate" @click="toJiaolian">
            <h1>{{ row.jiaolian.grade }}</h1>
            <img
              src="../../../../assets/images/icon-wuxijimore@2x.png"
              alt=""
            />
          </div>
          <div class="sai_list" v-if="row.jiaolian.list.length>0">
            <div v-for="(item, index) in row.jiaolian.list" :key="index">
              <div v-if="index < max3">
                <div class="list_header" v-if="item.type_name == '参赛'">
                  <h1>{{ item.saiqu_name }}</h1>
                  <img
                    src="../../../../assets/images/icon-wuxijisai@2x.png"
                    alt=""
                  />
                </div>
                <div class="list_header" v-if="item.type_name == '培训'">
                  <h1>{{ item.station_name }}</h1>
                  <img
                    src="../../../../assets/images/tag-peixun@2x.png"
                    alt=""
                  />
                </div>
                <div class="list_detail" v-if="item.type_name == '参赛'">
                  <img
                    src="../../../../assets/images/icon-grade@2x.png"
                    alt=""
                    style="margin-top: 0.15rem"
                  />
                  <h2>{{ item.prize }}</h2>
                </div>
                <div class="list_detail" v-if="item.type_name == '培训'">
                  <img
                  v-if="item.grade"
                    src="../../../../assets/images/icon-grade@2x.png"
                    alt=""
                    style="margin-top: 0.15rem"
                  />
                  <h2 v-if="item.grade">{{ item.grade }}</h2>
                </div>
                <div class="list_detail">
                  <img
                    src="../../../../assets/images/icon-time@2x.png"
                    alt=""
                    style="margin-top: 0.06rem"
                  />
                  <h3>{{ item.date }}</h3>
                </div>
                <div class="list_detail" v-if="item.type_name == '参赛'">
                  <img
                    src="../../../../assets/images/icon-people@2x.png"
                    alt=""
                    style="margin-top: 0.06rem"
                  />
                  <h3>{{item.mingcheng}}</h3>
                </div>
                <div class="br"></div>
              </div>
            </div>
            <div class="more" @click="max3change" v-if="max3show">
              点击查看更多
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!loading" style="text-align: center">
      <van-empty description="您还未实名认证，请认证后再查询" />
      <van-button
        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
        style="width: 3rem"
        size="normal"
        round
        v-rblink="{ name: 'CertIndex' }"
        >立即实名认证</van-button
      >
    </div>
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
  </div>
</template>
<style scoped>
.box {
  width: 100%;
  height: 100%;
  overflow: scroll;
  padding-bottom: 0.2rem;
  background: #f0eff4;
}
.header2 {
position: fixed;
top:0;
left: 0;
right: 0;
z-index: 10;
  padding-top: 30px;
  padding-left: 15px;
  padding-bottom: 30px;
  display: flex;
  background: linear-gradient(180deg, #ffffff 0%, #f0eff4 100%);
  box-shadow: 0px 1px 3px 0px rgba(237, 236, 241, 1);
}
.header2 img {
  display: block;
  width: 84px;
  height: 84px;
  border-radius: 80px;
}
.header_right {
  margin-left: 15px;
}
.header_right h1 {
  font-size: 21px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #191919;
  line-height: 30px;
}
.header_right h2 {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 19px;
  margin-top: 6px;
}
.content {
  margin-top: 34px;
  padding: 0 10px;
}
.content_title {
  display: flex;
}
.content_title h1 {
  font-size: 21px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
}
.content_title img {
  width: 76px;
  height: 9px;
  margin-top: 11px;
  margin-left: 15px;
}
.cate { 
    display: inline-block;
    border-radius: 12px;
    opacity: 0.62;
    height: 24px;
    border: 1px solid hsl(0, 0%, 59%);
    margin-top: 10px;
    /* display: flex; */
    padding: 0 12px;
    margin-right: 10px;
} 
.cate h1 {
  /* display: block; */
  font-size: 14px;
  display: inline;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
}
.cate img {
  width: 8px;
  height: 8px;
  margin-top: 8px;
  margin-left: 10px;
}
.sai_list {
  background: #ffffff;
  border-radius: 10px;
  padding-top: 0.1rem;
  margin-top: 0.32rem;
}
.list_header {
  display: flex;
  justify-content: space-between;
  margin-top: 0.3rem;
}
.list_header h1 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 20px;
  margin-left: 0.3rem;
}
.list_header img {
  width: 66px;
  height: 21px;
}
.list_detail {
  display: flex;
  margin-top: 0.2rem;
  margin-left: 0.3rem;
}
.list_detail img {
  width: 13px;
  height: 13px;
}
.list_detail h2 {
  font-size: 21px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin-left: 0.2rem;
}
.list_detail h3 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-left: 0.2rem;
}
.br {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin-top: 0.3rem;
}
.more {
  height: 30px;
  background: #fcfcfc;
  border-radius: 0px 0px 10px 10px;
  text-align: center;
  padding-top: 11px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.invite-level {
  display: flex;
}

.level_info {
  width: 0.99rem;
  height: 0.41rem;
  background: #ffffff;
  border-radius: 0.21rem;
  margin-right: 0.12rem;
  display: flex;
  justify-content: space-between;
}

.level_info img {
  width: 0.34rem;
  height: 0.34rem;
  margin-top: 0.035rem;
  margin-right: 0.1rem;
}

.title-icon {
  line-height: 0.41rem;
  margin-left: 0.1rem;
  padding-top: 0.06rem;
}
</style>
<script>
import Vue from "vue";
// import area from "../../../utils/area";
// import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import LoginDialog from "@/components/LoginDialog.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Divider)
  .use(Area)
  .use(RadioGroup)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "MyExperience",
  components: {
    PicUploader,
    LoginDialog,
  },
  data: function () {
    return {
      loading: true,
      saveLoading: false,
      loginShow: false,
      showArea: false,
      areaList: {},
      areaValue: "",
      submitType: "",
      row: {
        dabiao:[],
        id_cert:0,
        danwei: {},
        cert: {},
      },
      userDetail: {},
      formData: {},
      max1: 2,
      max2: 2,
      max3: 2,
      max1show: true,
      max2show: true,
      max3show: true,
    };
  },
  filters: {},
  mounted() {
    document.title = "我的经历";
    let that = this;
    this.fetch(); 
  },
  watch: {},
  destroyed() {},
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },

    toJiaolian() { 
        rbLink({
          name: "UserSearchJiaolian",
        }); 
    },
    max1change() {
      this.max1 = 10000;
      this.max1show = false;
    },
    max2change() {
      this.max2 = 10000;
      this.max2show = false;
    },
    max3change() {
      this.max3 = 10000;
      this.max3show = false;
    },

    toCaipan() { 
        rbLink({
          name: "UserSearchCaipan",
        }); 
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/user/experience",
        {},
        (res) => {
          that.row = res.data;
          that.loading = false;

          that.userDetail = res.data.user
          that.userDetail.stars = res.data.stars
        },
        (res) => {
          that.loading = false;
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    downloadDabiao(item){
      if(!item.cert_img_url){
            Toast('证书尚未生成，请联系管理员');
            return ;
      }

      var fileExtension = item.cert_img_url.split('.').pop().toLowerCase();
      console.log({
        name: 'downloadPic',
        query: {
          'filename' : item.grade_name+'.'+fileExtension,
              'url' : item.cert_img_url
    }
    });
    // return ;
      appEvent({
        name: 'downloadPic',
        query: {
          'filename' : item.grade_name+'.'+fileExtension,
              'url' : item.cert_img_url
        }
      });

    }, 
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Experience.vue?0ed1efe0